module.exports = __webpack_public_path__ + "assets/img/cb78535d8cbda26fa5cb3b4c231609e7.png";